import React from 'react';
import Cards from '../../Cards/Cards';
import {
  CARD_STYLE,
  OurServicesContainerWrapper,
  StyledConatiner,
  StyledContainer,
} from './OurServices.styled';
import CategoryHeading from '../../Heading/CategoryHeading';
import { Link } from 'react-router-dom';
import { useFeatureFlags } from '../../../contexts/FeatureFlagsContext';

const OurServices = ({ data }) => {
  const { headerData, content } = data;
  const featureFlag = useFeatureFlags();
  return (
    <StyledConatiner className='container'>
      <CategoryHeading
        headerLeftTitle={headerData?.header}
        headerLeftStyle={true}
      />
      <OurServicesContainerWrapper>
        {content?.map(({ img, title }) => {
          return (
            <Cards style={CARD_STYLE} key={title}>
              {featureFlag.INDIVIDUAL_SERVICES ? (
                <Link
                  to={`/services/b2c-logistics-services/${title.replace(
                    / /g,
                    '-'
                  )}`}
                  style={{ textDecoration: 'none' }}
                >
                  <StyledContainer>
                    <img src={img} alt='our-services' loading='lazy' />
                    <div>{title}</div>
                  </StyledContainer>
                </Link>
              ) : (
                <StyledContainer>
                  <img src={img} alt='our-services' loading='lazy' />
                  <div>{title}</div>
                </StyledContainer>
              )}
            </Cards>
          );
        })}
      </OurServicesContainerWrapper>
    </StyledConatiner>
  );
};

export default OurServices;
